import { render } from "./HoChiMinh.vue?vue&type=template&id=c91ca04e&scoped=true"
import script from "./HoChiMinh.vue?vue&type=script&scoped=true&lang=js"
export * from "./HoChiMinh.vue?vue&type=script&scoped=true&lang=js"

import "./HoChiMinh.vue?vue&type=style&index=0&id=c91ca04e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c91ca04e"]])

export default __exports__